module.exports = __webpack_public_path__ + "img/ercode_nm.57dbb1bd.png";